<template>
  <div class="yxtbiz-exam-arrange-makeup mb24">
    <yxt-row class="bg-white">
      <yxt-col>
        <yxt-form
          ref="ruleForm"
          :model="ruleForm"
          :rules="rules"
          label-position="top"
          size="small"
        >
          <!-- 选择试卷 -->
          <yxt-form-item :label="$t('pc_biz_ote_lbl_exampaper')" prop="examName" class="is-required">
            <yxt-select
              v-model="selectExamDrawerData.exam"
              class="w-p-100"
              :disabled="status !== 0"
              :placeholder="$t('pc_biz_ote_lbl_pleaseselect')"
              icon-name="more"
              hidden-option
              collapse-tags
              value-key="id"
              prop-label="name"
              @click.native="showSelectExam"
            />
          </yxt-form-item>
          <yxt-form-item :label="$t('pc_biz_ote_lbl_makeupexamname')" prop="name" class="is-required">
            <yxt-input
              v-model="ruleForm.name"
              :placeholder="$t('pc_biz_ote_tip_examnametip')"
              class="w-p-100"
              show-word-limit
              :maxlength="1000"
            />
          </yxt-form-item>
          <yxt-form-item :label="$t('pc_biz_ote_lbl_passscore')" prop="passScore" class="is-required">
            <div class="color-gray-9 mb12 lh22 mt9">{{ $t('pc_biz_ote_lbl_currentexamscore', [ruleForm.examId ? ruleForm.totalScore : '-']) }}</div>
            <yxt-radio-group v-model="ruleForm.passScoreType">
              <yxt-radio :label="1">
                {{ $t('pc_biz_ote_lbl_passscorebynum') /**固定分数 */ }}
                <yxt-input-number
                  v-model="ruleForm.passScore"
                  class="ml12"
                  :precision="2"
                  :step="1"
                  :max="ruleForm.totalScore || undefined"
                  :min="0"
                  :formatter="(value) => `${value||0}`"
                />
                <span class="ml8">{{ $t('pc_biz_ote_lbl_score') }}</span>
              </yxt-radio>
              <yxt-radio :label="2">
                {{ $t('pc_biz_ote_lbl_passscorebypercent') /**总分比例 */ }}
                <yxt-input-number
                  v-model="ruleForm.passScorePercent"
                  class="ml12"
                  :precision="1"
                  :step="1"
                  :max="100"
                  :min="0"
                  :formatter="(value) => `${value || 0}`"
                />
                <span class="ml8">%</span>
              </yxt-radio>
            </yxt-radio-group>
          </yxt-form-item>
          <yxt-form-item
            v-if="typeSetting"
            :label="$t('pc_biz_ote_lbl_makeuptype')"
            prop="assignUserCtrlList"
            class="is-required"
          >
            <yxt-checkbox-group v-model="ruleForm.assignUserCtrlList" direction="row">
              <yxt-checkbox :label="2" :disabled="status !== 0?'lock':false">{{ $t('pc_biz_ote_lbl_notakeleanerauto') }}</yxt-checkbox>
              <yxt-checkbox :label="4" :disabled="status !== 0?'lock':false">{{ $t('pc_biz_ote_lbl_nopassleanerauto') }}</yxt-checkbox>
              <yxt-checkbox :label="1" :disabled="status !== 0?'lock':false">{{ $t('pc_biz_ote_lbl_makeuptypeset') }}</yxt-checkbox>
            </yxt-checkbox-group>
            <users-container
              v-if="ruleForm.assignUserCtrlList.includes(1)"
              :users.sync="userlist"
              :readonly="true"
              :placeholder="$t('pc_biz_ote_btn_addmakeupexaminees')"
              @click="toViewPrescribedUser"
            />
          </yxt-form-item>
          <yxt-form-item class="is-required" :label="$t('pc_biz_ote_lbl_examlimit')">
            <yxt-checkbox v-model="isEntryTimeCtrl" class="" disabled="lock">{{ $t('pc_biz_ote_lbl_entertimelimit') }}</yxt-checkbox>
            <yxt-form-item class="is-required yxtbiz-exam-arrange-makeup__entrytime" prop="entryTime" :label="$t('pc_biz_ote_lbl_entertime')">
              <yxt-date-picker
                v-model="entryTime[0]"
                class="w-200"
                type="datetime"
                format="yyyy-MM-dd HH:mm"
                value-format="yyyy-MM-dd HH:mm:ss"
                :placeholder="$t('pc_biz_ote_lbl_starttime')"
              />
              <span class="ml10 mr10">{{ $t('pc_biz_ote_lbl_to') }}</span>
              <yxt-date-picker
                v-model="entryTime[1]"
                class="w-200"
                type="datetime"
                format="yyyy-MM-dd HH:mm"
                value-format="yyyy-MM-dd HH:mm:ss"
                :placeholder="$t('pc_biz_ote_lbl_endtime')"
              />
            </yxt-form-item>
          </yxt-form-item>
          <yxt-form-item prop="forceSubmitTime" class="mt-32px">
            <yxt-checkbox v-model="isForceSubmitCtrl" class="">{{ $t('pc_biz_ote_lbl_submittime') }}</yxt-checkbox>
            <div v-show="isForceSubmitCtrl" class="yxtbiz-exam-arrange-makeup__time">
              <yxt-date-picker
                v-model="ruleForm.forceSubmitTime"
                type="datetime"
                :placeholder="$t('pc_biz_ote_tip_submittime')"
                format="yyyy-MM-dd HH:mm"
                value-format="yyyy-MM-dd HH:mm:ss"
                style="width: 100%;"
              />
            </div>
          </yxt-form-item>
          <yxt-form-item prop="usedTimesLenMin" class="color-gray-9 mt-16px">
            <div class="flex flex-mid">
              <yxt-checkbox v-model="isUsedTimesCtrl">{{ $t('pc_biz_ote_lbl_examtimelength') }}</yxt-checkbox>

              <div v-show="isUsedTimesCtrl">
                <yxt-input-number
                  v-model="ruleForm.usedTimesLenMin"
                  :precision="0"
                  class="w-98 ml8"
                  :min="1"
                  :max="999"
                  @blur="numberInputMinus(ruleForm, 'usedTimesLenMin')"
                />
                <span class="ml8">{{ $t('pc_biz_ote_lbl_minites') }}</span>
              </div>
            </div>
          </yxt-form-item>
          <yxt-form-item prop="shortUsedTimesLenMin" class="color-gray-9 mt-16px">
            <div class="flex flex-mid">
              <yxt-checkbox v-model="isShortUsedTimesCtrl">{{ $t('pc_ulcd_ote_lbl_shorttime') }}</yxt-checkbox>

              <div v-show="isShortUsedTimesCtrl">
                <yxt-input-number
                  v-model="ruleForm.shortUsedTimesLenMin"
                  :precision="0"
                  class="w-98 ml8"
                  :min="1"
                  :max="999"
                  @blur="numberInputMinus(ruleForm, 'shortUsedTimesLenMin')"
                />
                <span class="ml8">{{ $t('pc_biz_ote_lbl_minites') }}</span>
              </div>
            </div>
          </yxt-form-item>
          <yxt-form-item v-if="multiSetting" prop="repeated" class="color-gray-9 mt-16px">
            <div class="flex flex-col">
              <yxt-checkbox v-model="isRepeated" class="">{{ $t('pc_biz_ote_lbl_multimakeup') }}</yxt-checkbox>
              <div v-if="isRepeated" class="bg-gray-1 ph20 mt8">
                <yxt-radio-group v-model="repeatedSetting">
                  <yxt-radio :label="1">{{ $t('pc_biz_ote_lbl_exam_times_nolimit' /* 不限次 */) }}</yxt-radio>
                  <!-- 限制 {0} 次 -->
                  <yxt-radio :label="2">
                    <yxtbiz-language-slot inline lang-key="pc_biz_ote_lbl_exam_times_limit_count">
                      <yxt-input-number
                        slot="0"
                        v-model="ruleForm.repeatTimes"
                        :precision="0"
                        controls-position="right"
                        class="ml8 w-82"
                        :min="2"
                        :max="99"
                        :disabled="repeatedSetting !== 2"
                        @blur="numberInputHandle(ruleForm,'repeatTimes', 2)"
                      />
                    </yxtbiz-language-slot>
                  </yxt-radio>
                </yxt-radio-group>
                <!-- （考生实际参与的考试次数） -->
                <span class="color-gray-6">{{ $t('pc_biz_ote_msg_exam_times_tips') }}</span>
              </div>
            </div>
          </yxt-form-item>
          <yxt-form-item :label="$t('pc_biz_ote_lbl_examdesc')" prop="description">
            <yxt-input
              v-model="ruleForm.description"
              type="textarea"
              :placeholder="$t('pc_biz_ote_tip_examdescinput')"
              rows="5"
              autocomplete="off"
              style="width: 100%;"
              :maxlength="10000"
            />
          </yxt-form-item>
        </yxt-form>
      </yxt-col>
    </yxt-row>
    <div class="fixedFooterStyle width640">
      <div class="text-right ph24">
        <yxt-button plain @click="cancle()">{{ $t('pc_biz_ote_btn_cancle') }}</yxt-button>
        <yxt-button type="primary" @click="submit()">{{ $t('pc_biz_ote_btn_confirm') }}</yxt-button>
      </div>
    </div>
    <yxt-drawer
      ref="selector"
      :title="$t('pc_biz_ote_btn_selectpaper')"
      size="960px"
      append-to-body
      modal-append-to-body
      :visible.sync="selectExamDrawerData.isShowSelectExamDrawer"
      :destroy-on-close="true"
      :direction="'rtl'"
      :before-close="()=>{saveExamSelect(true)}"
    >
      <yxtbiz-exam-selector
        v-model="selectExamDrawerData.exam"
        :function-code="functionCode"
        :data-permission-code="dataPermissionCodes.selectExam"
        :type="0"
        @select="saveExamSelect()"
      />
    </yxt-drawer>
    <participants-drawer
      ref="participantsDrawer"
      :group-select="groupSelect"
      :batch-id="batchId"
      :project-id="projectId"
      :task-id="taskId"
      @close="getUserList"
    />
  </div>
</template>

<script>
import { createArrangeMakeup, updateArrangeMakeup, getArrange, getArrangeResit, getExaminees } from './service';
import UsersContainer from './userMgmt/component/UsersContainer.vue';
import ParticipantsDrawer from './userMgmt/ParticipantsDrawer';
import {
  Form,
  FormItem,
  Drawer,
  DatePicker
} from 'yxt-pc';
import YxtbizExamSelector from 'yxt-biz-pc/packages/exam-selector';

export default {
  name: 'YxtbizExamArrangeMakeup',
  name_zh: '安排补考组件',
  components: {
    YxtbizExamSelector,
    YxtForm: Form,
    YxtFormItem: FormItem,
    YxtDrawer: Drawer,
    YxtDatePicker: DatePicker,
    UsersContainer,
    ParticipantsDrawer
  },
  eventList: [{
    type: 'save',
    handler: 'saved',
    label: '创建补考组件后的回调事件'
  }, {
    type: 'cancel',
    handler: 'cancle',
    label: '关闭补考组件'
  }],
  props: {
    // 考试安排ID
    arrangeId: {
      type: String,
      required: false,
      default: '',
      desc: '考试安排ID',
      setter: 'StringSetter'
    },
    // 补考ID
    makeupId: {
      type: String,
      required: false,
      default: '',
      desc: '补考ID',
      setter: 'StringSetter'
    },
    functionCode: {
      type: String,
      default: '',
      desc: '导航权限',
      setter: 'StringSetter'
    },
    // 是否可以设置多次补考
    multiSetting: {
      type: Boolean,
      required: false,
      desc: '是否可以设置多次补考',
      setter: 'BooleanSetter'
    },
    // 是否可以设置补考方式
    typeSetting: {
      type: Boolean,
      required: false,
      desc: '是否可以设置补考方式',
      setter: 'BooleanSetter'
    },
    dataPermissionCodes: {
      type: Object,
      default: () => {
        return {
          makeup: '', // 安排补考
          selectExam: '' // 控制选择试卷
        };
      },
      desc: '数据权限（makeup 安排补考，selectExam 控制选择试卷）',
      setter: 'JsonSetter'
    },
    // 循环考时的 安排的补考批次ID
    batchId: {
      type: String,
      default: '',
      desc: '循环考时的 安排的补考批次ID',
      setter: 'StringSetter'
    },
    // 支持项目内部添加补考人员
    projectId: {
      type: String,
      default: '',
      desc: '支持项目内部添加补考人员',
      setter: 'StringSetter'
    },
    // 支持项目多班次人员
    taskId: {
      type: String,
      default: '',
      desc: '支持项目多班次人员',
      setter: 'StringSetter'
    }
  },
  data() {
    let vm = this;
    const validatePassScore = (rule, value, callback) => {
      if (value === '') {
        callback(new Error(this.$t('pc_biz_ote_msg_passscorenotnull')));
      } else if (vm.ruleForm.passScoreType === 1 && parseFloat(value, 0) > parseFloat(vm.ruleForm.totalScore, 0)) {
        callback(new Error(this.$t('pc_biz_ote_msg_passscorenotovertotal')));
      } else {
        callback();
        return;
      }
    };
    const validateUsers = (rule, value, callback) => {
      if (!this.ruleForm.assignUserCtrlList || !this.ruleForm.assignUserCtrlList.length) {
        callback(new Error(this.$t('pc_biz_ote_lbl_plsselectmakeuptype')));
        return;
      }
      if (this.ruleForm.assignUserCtrlList.includes(1) && (!this.userlist || this.userlist.length === 0)) {
        callback(new Error(this.$t('pc_biz_ote_msg_arrangeuserselecttip')));
        return;
      }
      callback();
    };
    const validateExamTime = (rule, value, callback) => {
      let currentTime = new Date();
      let startTime = null;
      let endTime = null;
      if (this.isEntryTimeCtrl) {
        console.log(this.entryTime);
        if (!this.entryTime || this.entryTime.length <= 1 || !this.entryTime[0] || !this.entryTime[1]) {
          callback(new Error(this.$t('pc_biz_ote_msg_examentertimenotnull')));
          return;
        }
        startTime = new Date(this.entryTime[0].replace(/-/g, '/'));
        endTime = new Date(this.entryTime[1].replace(/-/g, '/'));
        if (endTime < currentTime) {
          callback(new Error(this.$t('pc_biz_ote_msg_endtimemustlasternow')));
          return;
        }
        if (startTime > endTime) {
          callback(new Error(this.$t('pc_biz_ote_msg_endtimemustlasterstarttime')));
          return;
        }
      }
      callback();
    };
    const validateSubmitTime = (rule, value, callback) => {
      let currentTime = new Date();
      let startTime = null;
      let endTime = null;
      if (this.isForceSubmitCtrl) {
        if (!this.ruleForm.forceSubmitTime) {
          callback(new Error(this.$t('pc_biz_ote_msg_submittimenotnull')));
          return;
        }
      }
      if (this.isForceSubmitCtrl) {
        endTime = new Date(this.ruleForm.forceSubmitTime.replace(/-/g, '/'));
        if (this.status === 0) {
          if (endTime < currentTime) {
            callback(new Error(this.$t('pc_biz_ote_msg_submittimemustlasternow')));
            return;
          }
        }

        if (this.isEntryTimeCtrl) {
          if (!this.entryTime || this.entryTime.length <= 1) {
            callback();
            return;
          }
          startTime = new Date(this.entryTime[0].replace(/-/g, '/'));
        }
        if (endTime <= startTime) {
          callback(new Error(this.$t('pc_biz_ote_msg_submittimemustlasterstarttime')));
          return;
        }
      }
      callback();
    };
    const validateTimesLen = (rule, value, callback) => {
      if (this.isUsedTimesCtrl) {
        if (!this.ruleForm.usedTimesLenMin) {
          callback(new Error(this.$t('pc_biz_ote_msg_examlengthnotnull')));
          return;
        }
      }
      callback();
    };
    const validateShortTimesLen = (rule, value, callback) => {
      if (this.isShortUsedTimesCtrl) {
        const { shortUsedTimesLenMin, usedTimesLenMin } = this.ruleForm;

        if (!shortUsedTimesLenMin) {
          callback(new Error(this.$t('pc_ote_tips_input_short_time')));
          return;
        }

        if (shortUsedTimesLenMin && this.isUsedTimesCtrl && usedTimesLenMin && ~~shortUsedTimesLenMin > ~~usedTimesLenMin) {
          // 最短答题时长不能超过统一时长
          callback(new Error(this.$t('pc_biz_ote_tips_shorttime1')));
        }
      }
      callback();
    };
    return {
      selectExamDrawerData: {
        isShowSelectExamDrawer: false,
        exam: {}
      },
      status: 0,
      userlist: [],
      ruleForm: {
        name: '',
        examId: '',
        examName: '',
        passScore: 0,
        passScorePercent: 0,
        passScoreType: 1,
        totalScore: 0,
        description: '',
        assignUserCtrlList: [2, 4],
        repeated: 0,
        entryTimeCtrl: 0, // 是否控制考试入场时间
        entryStartTime: '', // 考试入场开始时间
        entryEndTime: '', // 考试入场结束时间
        forceSubmitCtrl: 0, // 是否限制强制提交
        forceSubmitTime: '', // 强制提交时间
        usedTimesCtrl: 0, // 是否控制考试用时
        usedTimesLenMin: 0, // 考试允许用时(单位秒)
        shortUsedTimesCtrl: 0, // 是否控制最短作答时长
        shortUsedTimesLenMin: 0 // 考试最短作答时长设置(单位秒)
      },
      arrange: {},
      isEntryTimeCtrl: true,
      entryTime: [],
      isForceSubmitCtrl: false,
      isUsedTimesCtrl: false,
      isShortUsedTimesCtrl: false,
      isRepeated: false,
      rules: {
        name: [
          { required: true, message: this.$t('pc_biz_ote_msg_makeupexamnamenotnull'), trigger: 'blur' }
        ],
        examName: [
          { required: true, message: this.$t('pc_biz_ote_msg_exampapernotnull'), trigger: 'blur' }
        ],
        passScore: [
          { required: true, validator: validatePassScore, trigger: 'blur' }
        ],
        assignUserCtrlList: [
          { required: true, validator: validateUsers, trigger: 'blur' }
        ],
        entryTime: [
          { required: true, validator: validateExamTime, trigger: 'blur' }
        ],
        forceSubmitTime: [
          { required: false, validator: validateSubmitTime, trigger: 'blur' }
        ],
        usedTimesLenMin: [
          { required: false, validator: validateTimesLen, trigger: 'blur' }
        ],
        shortUsedTimesLenMin: [
          { required: false, validator: validateShortTimesLen, trigger: 'blur' }
        ]
      },
      repeatedSetting: 1 // 是否允许重复考设置
    };
  },
  computed: {
    groupSelect() {
      return [1, 2].indexOf(this.ruleForm.groupDataType) >= 0;
    }
  },
  watch: {
    'ruleForm.assignUserCtrlList': function(n, o) {
      this.$refs['ruleForm'].validateField('assignUserCtrlList');
    },
    'userlist': function() {
      this.$refs['ruleForm'].validateField('assignUserCtrlList');
    },
    isForceSubmitCtrl(v) {
      !v && this.$refs.ruleForm.validateField('forceSubmitTime');
    }
  },
  created() {
    if (this.makeupId) {
      this.status = 1;
      this.getMakeupInfo();
    } else {
      this.getArrangeInfo();
    }
    this.getUserList();
  },
  methods: {
    saveExamSelect(isClose) {
      this.selectExamCallback(this.selectExamDrawerData.exam);
      if (isClose || this.selectExamDrawerData.exam) {
        this.closeSelectExamDrawer();
      }
    },
    cancleExamSelect() {
      this.closeSelectExamDrawer();
    },
    deleteExam() {
      this.ruleForm.examId = '';
      this.ruleForm.examName = '';
      this.maxScore = 0;
    },
    getArrangeInfo() {
      getArrange(this.arrangeId, this.batchId).then(res => {
        res.usedTimesLenMin = res.usedTimesLen ? res.usedTimesLen / 60 : 0;
        res.shortUsedTimesLenMin = res.shortUsedTimesLen ? res.shortUsedTimesLen / 60 : 0;
        res.assignUserCtrlList = [2, 4];
        res.repeated = 0;
        res.repeatTimes = 0;
        this.ruleForm = res;
        this.ruleForm.originName = this.ruleForm.name;
        const makeupName = this.ruleForm.name + this.$t('pc_biz_ote_lbl_makeuptag');
        if (this.ruleForm.name && makeupName.length <= 1000) {
          this.ruleForm.name = makeupName;
        }
        this.loadFormData();
      }).catch(err => {
        if (err.error) {
          err = err.error;
        }
        this.$message({
          type: 'warning',
          message: err.message
        });
      });
    },
    getMakeupInfo() {
      getArrangeResit(this.makeupId).then(res => {
        res.usedTimesLenMin = res.usedTimesLen ? res.usedTimesLen / 60 : 0;
        res.shortUsedTimesLenMin = res.shortUsedTimesLen ? res.shortUsedTimesLen / 60 : 0;
        this.ruleForm = res;
        this.loadFormData();
      }).catch(err => {
        if (err.error) {
          err = err.error;
        }
        this.$message({
          type: 'warning',
          message: err.message
        });
      });
    },
    toViewPrescribedUser() {
      const obj = { arrangeId: this.arrangeId, makeupId: this.makeupId, uemAdding: 0 };
      this.$refs.participantsDrawer.show(obj);
    },
    getUserList() {
      getExaminees(this.arrangeId, {
        reqForResit: 1,
        batchId: this.batchId
      }).then(res => {
        this.userlist = res.datas;
      }).catch(err => {
        if (err.error) {
          err = err.error;
        }
        this.$message({
          type: 'warning',
          message: err.message
        });
      });
    },
    loadFormData() {
      this.ruleForm.entryTimeCtrl = 1;
      this.isEntryTimeCtrl = true;
      this.isForceSubmitCtrl = this.ruleForm.forceSubmitCtrl === 1;
      this.isUsedTimesCtrl = this.ruleForm.usedTimesCtrl === 1;
      this.isShortUsedTimesCtrl = this.ruleForm.shortUsedTimesCtrl === 1;
      this.ruleForm.passScoreType = this.ruleForm.passScoreType || 1;
      this.isRepeated = this.ruleForm.repeated === 1;

      // 根据是否允许重复考和次数赋值
      if (this.isRepeated) {
        this.repeatedSetting = [0, 1].includes(this.ruleForm.repeatTimes) ? 1 : 2;
        this.isRepeated = this.ruleForm.repeatTimes === 1 ? false : this.isRepeated;
      } else {
        this.repeatedSetting = 1;
      }

      if (this.isEntryTimeCtrl) {
        this.entryTime = [];
        if (this.ruleForm.entryStartTime) {
          this.entryTime.push(this.ruleForm.entryStartTime);
        }
        if (this.ruleForm.entryEndTime) {
          this.entryTime.push(this.ruleForm.entryEndTime);
        }
      }
      this.selectExamDrawerData.exam = {
        id: this.ruleForm.examId,
        name: this.ruleForm.examName,
        totalScore: this.ruleForm.totalScore
      };
    },

    getFormData() {
      this.ruleForm.entryTimeCtrl = this.isEntryTimeCtrl ? 1 : 0;
      this.ruleForm.entryStartTime = '';
      this.ruleForm.entryEndTime = '';
      if (this.isEntryTimeCtrl) {
        this.ruleForm.entryTime = [];
        this.ruleForm.entryStartTime = !this.entryTime || this.entryTime.length < 1 ? '' : this.entryTime[0];
        this.ruleForm.entryEndTime = !this.entryTime || this.entryTime.length < 2 ? '' : this.entryTime[1];
      }
      this.ruleForm.forceSubmitCtrl = this.isForceSubmitCtrl ? 1 : 0;
      this.ruleForm.usedTimesCtrl = this.isUsedTimesCtrl ? 1 : 0;
      this.ruleForm.shortUsedTimesCtrl = this.isShortUsedTimesCtrl ? 1 : 0;
      this.ruleForm.repeated = this.isRepeated ? 1 : 0;
    },

    // 这 3 个参数的 input最小值为 1 或者 0，如果直接修改ruleForm的话，传给接口后，可能参数会变成 dom里设置的 min值
    // 比如 repeatTimes最小值为 1，但是接口需要的是不限制次数时传 0，直接修改的话，network接口里的参数会变成 1，但是 console.log还是 0
    // 所以这里通过合并对象解决此问题，不直接修改 ruleForm
    inputDataComputed() {
      const inputData = {};

      if (!this.isUsedTimesCtrl) {
        this.ruleForm.usedTimesLenMin = 0;
      }
      inputData.usedTimesLenMin = parseInt(this.ruleForm.usedTimesLenMin, 10) || 0;
      inputData.usedTimesLen = inputData.usedTimesLenMin * 60;

      if (!this.isShortUsedTimesCtrl) {
        this.ruleForm.shortUsedTimesLenMin = 0;
      }
      inputData.shortUsedTimesLenMin = parseInt(this.ruleForm.shortUsedTimesLenMin, 10) || 0;
      inputData.shortUsedTimesLen = inputData.shortUsedTimesLenMin * 60;

      if (this.isRepeated) {
        inputData.repeatTimes = this.repeatedSetting === 2 ? this.ruleForm.repeatTimes : 0;
      } else {
        inputData.repeatTimes = 0;
      }

      return inputData;
    },
    checkFormData() {
      let isCheckOk = true;
      this.ruleForm.name = this.ruleForm.name.trim();
      this.$refs['ruleForm'].validate((valid) => {
        if (!valid) {
          isCheckOk = false;
          this.$message({
            type: 'error',
            message: this.$t('pc_biz_ote_msg_checkinput')
          });
        }
      });
      return isCheckOk;
    },
    saveFormData() {
      this.getFormData();
      if (!this.checkFormData()) {
        return;
      }
      if (!this.makeupId) {
        createArrangeMakeup(this.arrangeId, { ...this.ruleForm, ...this.inputDataComputed() }, this.functionCode, this.dataPermissionCodes.makeup, this.batchId).then((res)=>{
          this.ruleForm.id = res.id;
          this.saved();
        }).catch(err => {
          if (err.error) {
            err = err.error;
          }
          this.$message({
            type: 'warning',
            message: err.message
          });
        });
      } else {
        updateArrangeMakeup(this.makeupId, this.arrangeId, { ...this.ruleForm, ...this.inputDataComputed() }, this.functionCode, this.dataPermissionCodes.makeup, this.batchId).then((res)=>{
          this.saved();
        }).catch(err => {
          if (err.error) {
            err = err.error;
          }
          this.$message({
            type: 'warning',
            message: err.message
          });
        });
      }
    },
    saved() {
      this.$emit('save', { ...this.ruleForm, ...this.inputDataComputed()});
    },
    cancle() {
      this.$emit('cancle');
    },
    submit() {
      this.saveFormData();
    },
    // 打开选择试卷抽屉
    openSelectExamDrawer() {
      this.selectExamDrawerData.isShowSelectExamDrawer = true;
    },
    // 关闭快速建题抽屉
    closeSelectExamDrawer() {
      this.selectExamDrawerData.isShowSelectExamDrawer = false;
    },
    /**
     * 处理nuber组件 删除输入的默认数值处理
     * @param target 对象
     * @param prop 属性
     * @param dft 默认值
     */
    numberInputHandle(target, prop, dft) {
      if (isNaN(target[prop])) {
        this.$set(target, prop, dft);
      }
    },
    // 选择试卷回调方法
    selectExamCallback(exam) {
      if (exam) {
        this.ruleForm.examId = exam.id;
        this.ruleForm.examName = exam.name;
        this.ruleForm.totalScore = exam.totalScore;
      } else {
        this.ruleForm.examId = '';
        this.ruleForm.examName = '';
        this.ruleForm.totalScore = 0;
      }
      this.$nextTick().then(() => {
        this.$refs['ruleForm'].validateField('examName');
      });
    },
    showSelectExam() {
      if (this.status !== 0) {
        return;
      }
      this.openSelectExamDrawer();
    },

    numberInputMinus(form, field, min = 1) {
      const value = form[field];
      if (value === '' || value === undefined) {
        form[field] = min;
      }

      // 统一考试时长和最短答题时长的blur事件校验
      this.$refs.ruleForm.validateField('shortUsedTimesLenMin');
    }
  },
  directives: {
    'enter-number': el => {
      el.onkeyup = () => {
        if (el.nodeName === 'INPUT' && el.type === 'text') {
          if (el.value) {
            el.value = el.value.replace(/[^\d]/g, '');
          }
        } else {
          if (document.activeElement.nodeName === 'INPUT' && document.activeElement.type === 'text') {
            let val = document.activeElement.value;
            if (val) {
              document.activeElement.value = val.replace(/[^\d]/g, '');
            }
          }
        }
      };
    }
  }
};
</script>
